import { takeLatest, put } from "redux-saga/effects";
import Actions from "../action";
import { doGet, doPost } from "../../service/index";
import END_POINTS from "./EndPoints";
import {
    CAMERA_ALIGNMENT_LIST,
    CAMERA_ALIGNMENT_CAMERAS,
    CAMERA_ALIGNMENT_REQUEST,
} from "../action/CameraAlignmentAction";

export function* cameraAlignmentListSaga({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.CAMERA_ALIGNMENT_LIST, params);
        yield put(Actions.cameraAlignmentListSuccess(response));
        if (callback) callback(response);
    } catch (error) {
        yield put(Actions.cameraAlignmentListFailure({ error }));
        if (callback) callback(error);
    }
}

export function* cameraAlignmentCamerasSaga({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.CAMERA_ALIGNMENT_CAMERAS, params);
        yield put(Actions.cameraAlignmentCamerasSuccess(response));
        if (callback) callback(response);
    } catch (error) {
        yield put(Actions.cameraAlignmentCamerasFailure({ error }));
        if (callback) callback(error);
    }
}

export function* cameraAlignmentRequestSaga({ params, callback }) {
    try {
        const response = yield doPost(END_POINTS.CAMERA_ALIGNMENT_REQUEST, params);
        yield put(Actions.cameraAlignmentRequestSuccess(response));
        if (callback) callback(response);
    } catch (error) {
        yield put(Actions.cameraAlignmentRequestFailure({ error }));
        if (callback) callback(error);
    }
}

export default function* cameraAlignmentWatcher() {
    yield takeLatest(CAMERA_ALIGNMENT_LIST, cameraAlignmentListSaga);
    yield takeLatest(CAMERA_ALIGNMENT_CAMERAS, cameraAlignmentCamerasSaga);
    yield takeLatest(CAMERA_ALIGNMENT_REQUEST, cameraAlignmentRequestSaga);
}
